import { agentOperationLogHooks } from "@/manager";
import { SearchBar } from "./search-bar";
import { TableList } from "./table-list";

/** 操作日志 */
export const OperationLog = () => {
  const {
    operationLogs,
    searchFormData,
    loading,
    search,
    changePage,
    resetAndSearch,
    changeSearchForm,
  } = agentOperationLogHooks.useAgentOperationLogListData();

  return (
    <div className='w-full h-full flex flex-col overflow-hidden gap-5'>
      <SearchBar
        searchFormData={searchFormData}
        search={search}
        resetAndSearch={resetAndSearch}
        changeSearchForm={changeSearchForm}
      />
      <TableList
        operationLogs={operationLogs}
        loading={loading}
        total={searchFormData.total}
        page={searchFormData.page}
        pageSize={searchFormData.pageSize}
        changePage={changePage}
        search={search}
      />
    </div>
  )
}

